import z from 'zod';
import { scopedEntity, string, userRef, zoneRef, } from '../common';
export const fingerprintDeviceInfo = z.object({
    name: string,
    osName: string,
    osVersion: string,
    brand: string,
    model: string,
    appBundleId: string,
    appVersion: string,
});
export const fingerprintData = z.object({
    code: string,
    rssi: z.number(),
});
export const fingerprintScan = z.array(fingerprintData);
export const fingerprint = z.object({
    ...scopedEntity.shape,
    zone: zoneRef,
    deviceInfo: fingerprintDeviceInfo,
    description: string.nullable().default(null),
    data: z.array(fingerprintScan),
    beaconCodes: string.array().optional(),
    user: userRef,
    dataCount: z.number(),
    enabled: z.boolean(),
});
